export enum CommercialStocksEnum {
  Vendido = 'Vendido',
  Reservado = 'Reservado',
  Bloqueado = 'Bloqueado',
  Disponivel = 'Disponível',
}
